module.exports = __webpack_public_path__ + "img/br.c77a6fec.svg";